import { SplunkConfig } from '@resolutionlife/ui';

const SPLUNK_ENABLED_ENVS = ['development', 'production'];
const currentEnv = process.env.REACT_APP_ENV || 'development';
const isSplunkEnabled = SPLUNK_ENABLED_ENVS.includes(currentEnv);

const splunkConfig: SplunkConfig = {
  endpoint: isSplunkEnabled ? (process.env.REACT_APP_SPLUNK_HEC_ENDPOINT || '') : '',
  token: isSplunkEnabled ? (process.env.REACT_APP_SPLUNK_HEC_TOKEN || '') : '',
  source: 'cedant-ui',
  sourcetype: 'ui_log',
  index: isSplunkEnabled ? (process.env.REACT_APP_SPLUNK_INDEX || '') : '',
};

export default splunkConfig;
